// This file is for helpers that relate to any form validation messaging within the application

export const ALPHANUMERIC = 'Must contain letters or numbers';
export const CTRL_IN_USE = 'Control Number already in use';
export const DATE_GTE = value => `Cannot be before ${value}`;
export const DATE_GTE_NOW = 'Cannot be a date in the past';
export const GT_ZERO = 'Must be greater than 0';
export const GT_VAL = value => `Must be greater than ${value}`;
export const GTE_VAL = value => `Must be greater than or equal to ${value}`;
export const INTEGER = 'Must be an integer';
export const INVALID_DATE = 'Invalid Date Format';
export const LT_VAL_CHAR = value => `Must not contain more than ${value} characters`;
export const NUMERIC = 'Must contain only numbers';
export const RECIPIENT_REQUIRED = 'Add a Recipient to continue.';
export const REQUIRED = 'Required';
